import { render, staticRenderFns } from "./JsonDiffViewer.vue?vue&type=template&id=3c97f753&scoped=true"
import script from "./JsonDiffViewer.vue?vue&type=script&lang=js"
export * from "./JsonDiffViewer.vue?vue&type=script&lang=js"
import style0 from "./JsonDiffViewer.vue?vue&type=style&index=0&id=3c97f753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97f753",
  null
  
)

export default component.exports